import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

export const getChainInput = (searchCriteria: SearchCriteriaModel): string | null => searchCriteria.chain || null;
